<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <editor v-if="!loading" :api-key="apiKey"
                :class="isEmpty ? 'has_placeholder' : ''"
                :disabled="disabled"
                :id="uniqueValue"
                :init="wysiwyg.init"
                :key="uniqueValue"
                :placeholder="placeholder"
                v-model="textValue"/>
        <div v-if="internalErrorMessages" class="error--text">{{ internalErrorMessages[0] }}</div>
    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

import 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/media';
import 'tinymce/plugins/template';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/autolink';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/ui/oxide/content.min.css';

import VuelidateMixin from "@/components/General/Form/Mixin/VuelidateMixin";
import xss from "xss";

export default {
    mixins: [VuelidateMixin],
    components: {
        Editor,
    },
    props: {
        label: {
            required: false,
            default: null,
        },
        disabled: {
            required: false,
            default: false,
        },
        uniqueValue: {
            required: true,
        },
        placeholder: {
            required: false,
            default: 'Vul een tekst in',
            type: String
        },
        value: {
            required: true,
            default: '',
        },
        inline: {
            required: false,
            default: false,
        },
        rootBlock: {
            required: false,
            default: 'p',
        },
    },
    watch: {
        value() {
            this.isEmpty = false;
        }
    },
    data() {
        return {
            loading: true,
            isEmpty: false,
            showCreateModel: false,
            currentModal: null,
            route_id: null,
            editor: null,
            apiKey: null,
            wysiwyg: {
                init: {
                    skin: false,
                    content_css: false,
                    min_height: 300,
                    menubar: false,
                    inline: this.inline,
                    browser_spellcheck: true,
                    contextmenu: true,
                    forced_root_block: this.rootBlock,
                    force_br_newlines: false,
                    paste_as_text: false,
                    statusbar: false,
                    style_formats: [
                        {title: 'Paragraph', block: 'p'},
                        {title: 'Titel 2', block: 'h2'},
                        {title: 'Titel 3', block: 'h3'},
                        {title: 'Titel 4', block: 'h4'},
                    ],
                    paste_preprocess: function (plugin, args) {
                        const options = {
                            stripIgnoreTag: true,
                            whiteList: {
                                h1: [],
                                h2: [],
                                h3: [],
                                h4: [],
                                h5: [],
                                h6: [],
                                p: [],
                                b: [],
                                i: [],
                                strong: [],
                                em: [],
                                u: [],
                                ol: [],
                                ul: [],
                                li: [],
                                br: [],
                                a: ['href', 'title', 'target']
                            }
                        };
                        let XSSObj = new xss.FilterXSS(options);
                        args.content = XSSObj.process(args.content);

                    },
                    default_link_target: "_blank",
                    plugins: 'autoresize,pagebreak,paste,charmap,autolink,link,anchor,code,lists',
                    toolbar: 'code undo redo paste | bold italic underline numlist bullist | styleselect | link pagebreak | charmap',
                    setup: (editor) => {
                        this.editor = editor;
                    }
                }
            }
        }
    },
    computed: {
        textValue: {
            get: function () {
                if (this.value === null) {
                    return ' ';
                }
                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    methods: {
        focusin(event) {
            if (document.getElementsByClassName('tox').length > 0) {
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        }
    },
    mounted() {
        this.loading = true;
        this.$nextTick(() => {
            this.loading = false;
        });
    },
    created() {
        if (!this.value || this.value.replace(/<[^>]*>?/gm, '').length < 1) {
            this.isEmpty = true;
        }
        document.addEventListener('focusin', this.focusin);
    },
    beforeDestroy() {
        document.removeEventListener('focusin', this.focusin);
        this.editor = null;
    }
}
</script>
